<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" class="rightfloat">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">收录情况</div>
                  <div class="title_more2"><a href="">首页</a>>收录情况</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div>
                    《{{$store.state.Name}}》是“中国科技核心期刊(中国科技论文统计源期刊)”、“中国学术期刊（光盘版）全文收录期刊”、“中国期刊全文数据库全文收录期刊”、“中国核心期刊数据库源期刊”、“中国科学期刊综合评价数据库统计源期刊”、“中文科技期刊数据库收录期刊”、“国家新闻出版总署期刊资料库收藏期刊”、“中国科技期刊引证报告统计源期刊”，并被《中国电子科技文摘》、中国电子网”和“国家科技部万方数据中心”维普期刊数据库等多家资料检索系统收录。
                  </div>
                </div>

              </div>
            </div>
          </el-col>
          <common-sidebar></common-sidebar>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        keywords:'',
        activeName: 'first'


      }
    },
    components: {},
    methods: {

    }
  }
</script>

<style scoped>

</style>
